module.exports = __webpack_public_path__ + "img/Haarologinnen.42cae308.jpg";